// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_to-object.js
// module id = 139
// module chunks = 2 3 6 7 8 10 11 12 13 14 16 17 21 22 23 25 26 27 28 29 31 32 33 34 35 36 37 38 40 41 45 49 51